import styled from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div<{ isActive?: boolean }>`
    background-color: var(--color-primary-white);
    border-radius: 4px;
    box-shadow: 0 0 0 1px var(--color-grey-6);

    ${({ isActive }) =>
        isActive &&
        `
        box-shadow: 0 0 0 2px var(--color-grey-7);
    `};
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--spacing-2);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        column-gap: calc(var(--spacing-3) / 2);
        align-items: center;
        justify-content: space-between;

        @supports not (column-gap: 0) {
            & > span {
                margin-left: calc(var(--spacing-3) / 2);
            }
        }
    }
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-2);
    padding: var(--spacing-2);
    border-top: 1px solid var(--color-grey-6);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        row-gap: normal;
    }

    @supports not (row-gap: 0) {
        & > div:nth-child(1) {
            margin-bottom: var(--spacing-2);

            @media (min-width: ${breakpoints.md}) {
                margin-bottom: 0;
            }
        }
    }
`;

export const Content = styled.div`
    &:not(:empty) {
        padding-inline: var(--spacing-2);
        padding-block-end: var(--spacing-3);

        @supports not (padding-inline: 0) {
            padding-bottom: var(--spacing-3);
            padding-left: var(--spacing-2);
            padding-right: var(--spacing-2);
        }
    }
`;

export const Details = styled.div<{ active: boolean }>`
    display: ${({ active }) => (active ? "block" : "none")};
    padding: var(--spacing-2);
    background-color: var(--color-grey-1);
    border-top: 1px solid var(--color-grey-6);
`;

export const DetailsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-block-end: var(--spacing-2);
    padding-block-end: var(--spacing-2);
    border-bottom: 1px solid var(--color-grey-6);

    @supports not (padding-block: 0) {
        margin-bottom: var(--spacing-2);
        padding-bottom: var(--spacing-2);
    }
`;

export const Title = styled.div`
    display: flex;
    column-gap: var(--spacing-1);
    align-items: center;

    @supports not (column-gap: 0) {
        svg {
            margin-right: var(--spacing-1);
        }
    }
`;
